module.exports = __webpack_public_path__ + "img/DG.ec7fa536.svg";